const { accountNo } = require('./account-no')
const { digits } = require('./digits')
const { noSpaces } = require('./no-spaces')
const { ssn } = require('./ssn')
const { thousands } = require('./thousands')
const { decimals } = require('./decimals')
const { businessId } = require('./business-id')

module.exports = {
  accountNo,
  digits,
  noSpaces,
  ssn,
  thousands,
  decimals,
  businessId
}
